import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Home from '@/pages/Home';
import CategoryView from '@/pages/CategoryView';
import BookView from '@/pages/BookView';
import DrawScreen from '@/pages/DrawScreen';
import NotFound from '@/pages/NotFound';

const App: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col bg-[var(--bg-primary)]">
      {/* Subtle spiritual symbols background overlay */}
      <div
        aria-hidden="true"
        className="fixed inset-0 -z-10 pointer-events-none"
        style={{
          backgroundImage: 'url(/spiritual-pattern.svg)',
          backgroundRepeat: 'repeat',
          backgroundSize: '1000px 1000px',
        }}
      />
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/category/:categoryId" element={<CategoryView />} />
          <Route path="/book/:bookId" element={<BookView />} />
          <Route path="/oracle" element={<DrawScreen />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

export default App;
